@import 'styles/mixins';
@import 'styles/variables';

.antdOverride {
  z-index: 2147483001; // Higher than intercom button
  :global .ant-popover-inner-content {
    padding: 0;
  }

  :global .ant-popover-arrow {
    display: none;
  }
}

.tooltipContent {
  background: $navy-90;
  color: $white;
  display: flex;
  padding: 16px;
  width: 328px;
  border-radius: 8px;
  @include ui-sm-text;

  & svg {
    fill: $white;
    margin-right: 8px;
  }
}

.tooltipHeader {
  @include ui-md-bold;
  margin-bottom: 8px;
}
